module.exports = __webpack_public_path__ + "img/logo-vertical.f9460b13.png";